import { CollectionAction } from '../collection-action.interface';
import { CollectionActions } from '../collection-actions.enum';
import { CollectionState } from '../collection-state.interface';
import onAddAssetRequest from './on-add-asset-request';
import onRemoveAssetRequest from './on-remove-asset-request';

const onRequest = (
  state: CollectionState,
  action: CollectionAction,
): CollectionState => {
  switch (action.type) {
    case CollectionActions.ADD_ASSETS_REQUEST:
      return onAddAssetRequest(state, action);

    case CollectionActions.REMOVE_ASSETS_REQUEST:
      return onRemoveAssetRequest(state, action);

    case CollectionActions.CREATE_REQUEST:
    case CollectionActions.UPDATE_REQUEST:
    case CollectionActions.UPDATE_LIST_REQUEST:
    case CollectionActions.DELETE_REQUEST:
    default:
      return {
        ...state,
        isUpdating: true,
      };
  }
};

export default onRequest;
